import axios from '../../utils/axios';
import CRUD from './crud'

const bookingPrices = new CRUD('booking-prices', 'superior-judge')

export default Object.assign(
    bookingPrices,
    {
        reducers: {
            ...bookingPrices.reducers
        },


    }
)
